import React from 'react'
import { Container } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';

export default function About(props) {
    
    return (
        <Container style={{ color: props.mode === 'dark' ? 'white' : 'black' }}>
            <h1 className='my-3'>About Me</h1>
            <Accordion defaultActiveKey="0">
                <Accordion.Item>
                    <Accordion.Header>Created By Jatin Rana</Accordion.Header>
                    <Accordion.Body>
                        Hello guys, this is my first React Website.<br /> On this website you can format your text and if you have other idea to plugin into this website please contact me at <b>jatinrana120@gmail.com</b>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Container>
    );
}
